import React from 'react'
import PropTypes from 'prop-types'
import Lightbox from 'react-images'

const GalleryWithLightbox = (Gallery) => class SimpleLightbox extends React.Component {
  constructor() {
    super()

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0,
    }

    this.openLightbox = this.openLightbox.bind(this)
    this.closeLightbox = this.closeLightbox.bind(this)
    this.gotoNext = this.gotoNext.bind(this)
    this.gotoPrevious = this.gotoPrevious.bind(this)
    this.handleClickImage = this.handleClickImage.bind(this)
  }

  openLightbox(index, e) {
    e.preventDefault()

    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
    })
  }

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    })
  }

  gotoNext() {
    this.setState({ currentImage: this.state.currentImage + 1 })
  }

  gotoPrevious() {
    this.setState({ currentImage: this.state.currentImage - 1 })
  }

  handleClickImage(e) {
    e.stopPropagation()

    if (this.state.currentImage + 1 === this.props.imagesUrls.length) return;

    this.gotoNext()
  }

  render() {
    return (
      <div>
        <Gallery
          {...this.props}
          onImageClick={this.openLightbox}
        />
        <Lightbox
          currentImage={this.state.currentImage}
          images={this.props.imagesUrls}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.handleClickImage}
          onClickNext={this.gotoNext}
          onClickPrev={this.gotoPrevious}
          onClose={this.closeLightbox}
          backdropClosesModal
        />
      </div>
    )
  }
}

GalleryWithLightbox.propTypes = {
  imagesUrls: PropTypes.array.isRequired,
  attachments: PropTypes.array.isRequired,
}

export default GalleryWithLightbox
